var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 9.21993C18.29 9.21993 17.55 7.93993 18.45 6.36993C18.97 5.45993 18.66 4.29993 17.75 3.77993L16.02 2.78993C15.23 2.31993 14.21 2.59993 13.74 3.38993L13.63 3.57993C12.73 5.14993 11.25 5.14993 10.34 3.57993L10.23 3.38993C9.78 2.59993 8.76 2.31993 7.97 2.78993L6.24 3.77993C5.33 4.29993 5.02 5.46993 5.54 6.37993C6.45 7.93993 5.71 9.21993 3.9 9.21993C2.86 9.21993 2 10.0699 2 11.1199V12.8799C2 13.9199 2.85 14.7799 3.9 14.7799C5.71 14.7799 6.45 16.0599 5.54 17.6299C5.02 18.5399 5.33 19.6999 6.24 20.2199L7.97 21.2099C8.76 21.6799 9.78 21.3999 10.25 20.6099L10.36 20.4199C11.26 18.8499 12.74 18.8499 13.65 20.4199L13.76 20.6099C14.23 21.3999 15.25 21.6799 16.04 21.2099L17.77 20.2199C18.68 19.6999 18.99 18.5299 18.47 17.6299C17.56 16.0599 18.3 14.7799 20.11 14.7799C21.15 14.7799 22.01 13.9299 22.01 12.8799V11.1199C22 10.0799 21.15 9.21993 20.1 9.21993ZM12 15.2499C10.21 15.2499 8.75 13.7899 8.75 11.9999C8.75 10.2099 10.21 8.74993 12 8.74993C13.79 8.74993 15.25 10.2099 15.25 11.9999C15.25 13.7899 13.79 15.2499 12 15.2499Z",
    fill: "#F8F8FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingSolid);
export default __webpack_public_path__ + "static/media/setting-solid.ed259a929e102e84ee2495babfac59e3.svg";
export { ForwardRef as ReactComponent };